// choices/roomChoices.js
const roomChoicesBg = [
  { label: "Хол 🛋️", value: "living-room" },
  { label: "Кухня 🎛️", value: "kitchen" },
  { label: "Трапезария 🍴", value: "dining-room" },
  { label: "Спалня 🛏️", value: "bedroom" },
  { label: "Баня 🛁", value: "bathroom" },
  { label: "Детска стая 👶", value: "kids-room" },
  { label: "Юношеска стая 👦", value: "teen-room" },
];

export default roomChoicesBg;
